var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-col',{attrs:{"cols":"12"}},[_vm._v("Page not found 404")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }